import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import device from "current-device";
import {API_INDEX_MAIN_GAME, GAME_ROUTE} from "../../../utils/consts";
import parse from "html-react-parser";
import i18next from "i18next";
import {NavLink} from "react-router-dom";
import {PopupContext} from "../../../App";
import {ScrollToPosition} from "../../../utils/ScrollToPosition";
import {useFetching} from "../../../hooks/useFetching";
import cookie from "js-cookie";
import ApiIndexMainGame from "../../../services/Index/MainGame";
import {observer} from "mobx-react-lite";
import Loader from "../../Loader";

// import top from '../../../img/top.jpg'
// import top_mobile from '../../../img/top_mobile.jpg'
// import Loading from "../../Loading";

const MainGame = ({ loading, setLoading }) => {
    const {t} = useTranslation();
    const curr_lang = cookie.get('i18next');
    const [, setPopupContext] = useContext(PopupContext);
    const [mainGame, setMainGame] = useState({});
    // const [mainGame, setMainGame] = useState({id: '65', title: 'Rise Of Imperium', text: '<p>Добро пожаловать в «Rise Of Imperium»! Приготовьтесь очутиться в самом богатом и знаменитом по сей день городе этого мира - Риме. Не стоит долго раздумывать, воспользуйтесь шансом пройти сквозь временную петлю и оказаться в самом сердце того единого символа мощи и несокрушимости могущественной Империи!</p>', img: top, img_mobile: top_mobile, status: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D',});

    const handlePopup = (e) => {
        if (!device.mobile()) {
            e.preventDefault();
            ScrollToPosition(false, window.pageYOffset);
            setPopupContext(e.target.href)
        }
    };

    const [FunctionApiIndexMainGame] = useFetching(async () => {
        try {
            const response = await ApiIndexMainGame.getApiIndexMainGame(API_INDEX_MAIN_GAME);
            setMainGame(response.data.main_game);
        } finally {
            setLoading(true);
        }
    });

    useEffect(() => {
        FunctionApiIndexMainGame();
    }, [curr_lang]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <section style={{paddingTop: !mainGame?.status && document.querySelector('header').offsetHeight}}>
                {!loading && <Loader />}
                {mainGame?.status && <section id="js-first_page" className="first_page page_scroll">
                    <div className="block_center">
                        <div className="virtual">
                            <div className="row">
                                <div className="virtual_left">
                                    <div className="virtual_left_img">
                                        {device.mobile()
                                            ? <img src={mainGame.img_mobile} alt="" />
                                            : <img src={mainGame.img} alt="" />
                                        }
                                    </div>
                                </div>
                                <div className="virtual_right">
                                    <div className="virtual_right_box">
                                        <div className="title_block">
                                            <h1>{mainGame.title}</h1>
                                            {mainGame.text && parse(mainGame.text)}
                                        </div>
                                        <div className="virtual_right_box_links">
                                            <a
                                                onClick={handlePopup}
                                                href={mainGame.play_game_url}
                                            >{t('PLAY DEMO')}</a>
                                            <NavLink
                                                to={`/${i18next.language}${GAME_ROUTE}/${mainGame.id}/main/`}>{t('READ MORE')}</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mouse_bottom">
                        <div className="mouse">
                            <p>{t('Scroll to New Games')}</p>
                        </div>
                    </div>
                </section>}
            </section>
        </>
    );
};

export default observer(MainGame);